var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c(
        "v-autocomplete",
        _vm._b(
          {
            staticClass: "body-2",
            attrs: {
              loading: _vm.isLoading,
              items: _vm.items,
              "search-input": _vm.textInput,
              "item-text": _vm.itemText,
              "item-value": _vm.itemValue,
              placeholder:
                _vm.placeholder ||
                _vm.$vuetify.lang.t(
                  "$vuetify.USER_MANAGE.STUDENT_LIST.LABEL_SELECT_STUDENT_GROUP"
                ),
              label:
                _vm.label ||
                _vm.$vuetify.lang.t(
                  "$vuetify.USER_MANAGE.STUDENT_LIST.PLACEHOLDER_SELECT_STUDENT_GROUP"
                ),
              value: _vm.value,
              multiple: _vm.isMultipleSelect,
              chips: _vm.isMultipleSelect,
              outlined: "",
              "return-object": "",
              dense: "",
            },
            on: {
              "update:searchInput": function ($event) {
                _vm.textInput = $event
              },
              "update:search-input": function ($event) {
                _vm.textInput = $event
              },
              change: (value) => _vm.onChangeValue(value),
            },
            scopedSlots: _vm._u(
              [
                _vm.isMultipleSelect
                  ? {
                      key: "selection",
                      fn: function (data) {
                        return [
                          !data.item.disabled
                            ? _c(
                                "v-chip",
                                _vm._b(
                                  {
                                    attrs: {
                                      small: "",
                                      "input-value": data.selected,
                                    },
                                  },
                                  "v-chip",
                                  data.attrs,
                                  false
                                ),
                                [_vm._v(" " + _vm._s(data.item.title) + " ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    }
                  : null,
              ],
              null,
              true
            ),
          },
          "v-autocomplete",
          this.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }